export default __webpack_public_path__ + "static/media/IMG_4913.33e374c0.png";